import { usePetitionDetails } from './petitionDetails';

export function useCaptchaEnabled(): boolean {
	const { requireHumanVerification } = usePetitionDetails();

	return requireHumanVerification;
}
